import { FC } from "react";
import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import { ProviderType } from "@/services/cloudchipr.api";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { generateCostTypeProvidersText } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/utils/helpers";

interface CostTypeSelectItemProvidersProps {
  providers: ProviderType[];
  hideTooltip?: boolean;
}

export const CostTypeSelectItemProviders: FC<
  CostTypeSelectItemProvidersProps
> = ({ providers, hideTooltip }) => {
  let tooltipTitle = "";

  if (!hideTooltip) {
    const providerText = generateCostTypeProvidersText(providers);
    if (providers.length === 1) {
      tooltipTitle = `This cost type applies only to ${providerText}. When selected, GCP and Azure will continue to show actual costs.`;
    } else {
      tooltipTitle = `This cost type applies only to ${providerText}. When selected, GCP will continue to show actual costs.`;
    }
  }
  return (
    <Tooltip title={tooltipTitle} arrow placement="right">
      <AvatarGroup sx={avatarGroupStyles}>
        {providers?.map((provider) => {
          return (
            <Avatar
              key={provider}
              sx={{ bgcolor: "white", height: 23, width: 23 }}
            >
              <ProviderIcon provider={provider} key={provider} width={13} />
            </Avatar>
          );
        })}
      </AvatarGroup>
    </Tooltip>
  );
};

const avatarGroupStyles = {
  "& >.MuiAvatar-root": {
    border: 1,
    borderColor: "grey.200",
  },
  "& .MuiAvatar-root:nth-of-type(1)": {
    height: 23,
    width: 23,
    fontSize: 13,
  },
};
